<template>
  <div>
    <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>

    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.ministry_name" :error="form.errors.ministry_name" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Name of Ministry" required="true" placeholder="i.e Ministry of Interior and Local Governess" />
          <text-input v-model="form.name_eng_short" :error="form.errors.name_eng_short"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Short Name" placeholder="i.e MILG" />
          <text-input v-model="form.reference_code" :error="form.errors.reference_code"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Code" placeholder="i.e 1001" />
          <text-input v-model="form.latitude" :error="form.errors.latitude" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Latitude" placeholder="i.e 7.12345678" />
          <text-input v-model="form.longitude" :error="form.errors.longitude" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Longitude" placeholder="i.e 124.12345678" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-full lg:w-1/2" type="file"
            accept="image/*" label="Logo" />
          <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status of Ministry"
            class="pb-8 pr-6 w-full lg:w-1/2"></status-toogle-button>
        </div>
        <Button :type="type" :name="title" :url="createUrl" :loading="form.processing"></Button>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { ref, toRefs, inject } from 'vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import Breadcrumbs from '@/Shared/Breadcrumbs'
import Button from '@/Shared/Button'
import FileInput from '@/Shared/FileInput'
export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    StatusToogleButton,
    Breadcrumbs,
    Button,
    FileInput
  },
  layout: Layout,
  remember: 'form',
  setup(props) {
    const { regions } = toRefs(props)
    const form = useForm({
      ministry_name: null,
      name_eng_short: null,
      reference_code: null,
      latitude: null,
      longitude: null,
      status: true,
      logo: null
    })
    const type = ref('create')
    const title = ref('Ministry')
    const url = ref('/backend/ministries')
    const createUrl = ref('')
    const swal = inject('$swal')
    const store = () => {
      swal({
        title: 'Are you sure?',
        text: "You want to proceed with this action",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.isConfirmed) {
          form.post(`${url.value}`, { forceFormData: true, })
          swal.fire(
            'Added!',
            'Your infomation has been Added.',
            'success'
          )
        }
      });

    }
    return {
      form,
      regions,
      type,
      title,
      url,
      createUrl,
      store
    }
  }
}
</script>
